import { useState } from "react";
import Header from "../admin/components/Header";
import Footer from "../admin/components/Footer";
import styles from "../admin/components/layout.module.css";

const AdminLayout = ({ children }) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (<>
    <div className={styles.DashboardMainBody}>
      <Header onMenuToggle={() => setMobileNavOpen((prev) => !prev)} />
      <Footer
        menuName={children?.props?.menuName}
        mobileOpen={mobileNavOpen}
        onClose={() => setMobileNavOpen(false)}
      />
      <div className={styles.ContentArea}>
        {children}
      </div>
    </div>
  </>);
};

export default AdminLayout;